import { logger } from 'cadenza/utils/logging';
import { Rectangle } from 'cadenza/map/geom/rectangle';

/**
 * Creates the renderer function for an image object
 *
 * @param {HTMLImageElement | HTMLCanvasElement} image
 * @param { boolean } keepAspect - If false the aspect ratio is not kept
 * @return { RenderFunction } the render function
 */
export function getImageObjectRenderer (image, keepAspect = true) {
  return ([ [ from, , to ] ], { context, feature }) => {
    if (!(feature.getGeometry() instanceof Rectangle)) {
      logger.error('trying to draw other geometry with image object renderer', arguments);
      return;
    }

    if (!(from && to)) {
      return;
    }
    const x1 = Math.round(from[0]);
    const y1 = Math.round(from[1]);
    const x2 = Math.round(to[0]);
    const y2 = Math.round(to[1]);
    let x, y;

    const requestedWidth = Math.abs(x2 - x1);
    const requestedHeight = Math.abs(y2 - y1);
    const imageAspectRatio = image.width / image.height;
    const [ width, height ] = adjustExtentKeepingAspectRatio(requestedWidth, requestedHeight, imageAspectRatio);

    if (keepAspect) {
      x = Math.min(x1, x2) + (requestedWidth - width) / 2;
      y = Math.min(y1, y2) + (requestedHeight - height) / 2;
    } else {
      x = Math.min(x1, x2);
      y = Math.min(y1, y2);
    }

    context.save();
    context.drawImage(image, x, y, keepAspect ? width : requestedWidth,  keepAspect ? height : requestedHeight);
    context.restore();
  };
}

function adjustExtentKeepingAspectRatio (requestedWidth, requestedHeight, aspectRatio) {
  const requestedAspectRatio = requestedWidth / requestedHeight;
  if (requestedAspectRatio > aspectRatio) {
    return [ requestedHeight * aspectRatio, requestedHeight ];
  }
  return [ requestedWidth, requestedWidth / aspectRatio ];
}
